import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ServiceGroup } from '../../../shared/models/service-group.model';
import { LogService } from 'src/app/shared/services/log.service';

@Injectable({ providedIn: 'root' })
export class ServiceGroupService {
  apiHost: string = environment.apiHost;
  groupArr: ServiceGroup[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  async loadGroups() {
    this.groupArr = await this.getAllGroups();
    if (this.groupArr == null) this.groupArr = [];
    this.groupArr = this.groupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  async loadActiveGroups() {
    this.groupArr = await this.getActiveGroups();
    if (this.groupArr == null) this.groupArr = [];
    this.groupArr = this.groupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }  

  getActiveGroups(): Promise<ServiceGroup[]> {
    let promise = new Promise<ServiceGroup[]>((resolve, reject) => {
      return this.http
        .get<ServiceGroup[]>(this.apiHost + '/servicegroup/getallactive')
        .toPromise()
        .then(
          (data) => {
            resolve(data.sort((a, b) => (a.name < b.name ? -1 : 1)));
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active Groups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllGroups(): Promise<ServiceGroup[]> {
    let promise = new Promise<ServiceGroup[]>((resolve, reject) => {
      return this.http
        .get<ServiceGroup[]>(this.apiHost + '/servicegroup/getall')
        .toPromise()
        .then(
          (data) => {
            resolve(data.sort((a, b) => (a.name < b.name ? -1 : 1)));
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Groups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addGroup(ServiceGroup: ServiceGroup): Promise<ServiceGroup> {
    let promise = new Promise<ServiceGroup>((resolve, reject) => {
      return this.http
        .post<ServiceGroup>(this.apiHost + '/ServiceGroup/add', ServiceGroup)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Service Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  saveGroup(ServiceGroup: ServiceGroup): Promise<ServiceGroup> {
    let promise = new Promise<ServiceGroup>((resolve, reject) => {
      return this.http
        .post<ServiceGroup>(this.apiHost + '/ServiceGroup/update', ServiceGroup)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update Service Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  setDefault(ServiceGroup: ServiceGroup): Promise<ServiceGroup> {
    let promise = new Promise<ServiceGroup>((resolve, reject) => {
      return this.http
        .post<ServiceGroup>(
          this.apiHost + '/ServiceGroup/setdefault',
          ServiceGroup
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Set Default Service Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteGroup(GroupId: number): Promise<ServiceGroup> {
    let promise = new Promise<ServiceGroup>((resolve, reject) => {
      return this.http
        .post<ServiceGroup>(
          this.apiHost + '/servicegroup/delete?GroupId=' + GroupId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete Service Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteGroup(GroupId: number): Promise<ServiceGroup> {
    let promise = new Promise<ServiceGroup>((resolve, reject) => {
      return this.http
        .post<ServiceGroup>(
          this.apiHost + '/servicegroup/undelete?GroupId=' + GroupId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Undelete Service Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
